import React, { useState } from "react";
import { Navbar, Nav, Image } from "react-bootstrap";
import { Grid } from '@material-ui/core';
import { FaBars, FaAngleDown } from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.css";
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { withTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom'
import env, { REACT_APP_FE_URL } from '../env'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    color: "rgb(218, 218, 218)",
    fontSize: "14px",
  },
  navItem: {
    [theme.breakpoints.down("sm")]: {
      marginRight: "0rem",
      padding: "3px",
      fontWeight: "500",
      color: "rgb(218, 218, 218) !important",
      borderBottom: "1px solid #e2e2e2",
      marginBottom: ".25rem"
    },
    [theme.breakpoints.up("sm")]: {
      marginRight: "2.5rem",
      padding: "3px",
      fontWeight: "500",
      fontSize: "14px",
      color: "rgb(218, 218, 218) !important",
    },
  }
}));

const options = [
  'Select Language',
  'id',
  'en',
];

function NavbarHomepage({ section, t, i18n, openPricingInfo }) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const history = useHistory()
  const CONTACT_US_URL = `${env.REACT_APP_FE_URL}/contactus`

  const handleClickListItem = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, index) => {
    i18n.changeLanguage(options[index])
    setSelectedIndex(index);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const gotoSection = (e) => {
    if (window.location.pathname === '/') {
      section(e.target.innerText);
    } else {
      history.push({
        pathname: "/",
        state:{ section: e.target.innerText }
      })    
    }
  };

  const handlePricingInfo = () => {
    openPricingInfo()
  };

  // const gotoDocsPage = (e) => {
  //   window.location.href = 'https://quickey-docs.netlify.app'
  // };

  // const gotoContactUsPage = (e) => {
  //   history.push('/contactus')    
  // }

  const gotoSignUpPage = (e) => {
    history.push('/register')    
  }

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} md={12}>
          <Navbar
          id="navbar"
          className="mt-1"
          color="light"
          expand="lg"
        >
          <Navbar.Brand href="/">
            <Image
              className="main-logo"
              src="/quickey-white.png"
              style={{ width: "50px" }}
              alt="quickey"
            />
          </Navbar.Brand>
          <div className={classes.root}>
            <List component="nav" aria-label="Device settings">
              <ListItem
                button
                aria-haspopup="true"
                aria-controls="lock-menu"
                aria-label="when device is locked"
                onClick={handleClickListItem}
              >
                <ListItemText primary={t('nav.lang')} />
                <span>&thinsp;&thinsp;|&thinsp;&thinsp;</span>
                <ListItemText primary={options[selectedIndex]} />
                <span>&thinsp;<FaAngleDown className="font-size-12" /></span>
              </ListItem>
            </List>
            <Menu
              id="lock-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {options.map((option, index) => (
                <MenuItem
                  key={option}
                  disabled={index === 0}
                  selected={index === selectedIndex}
                  onClick={(event) => handleMenuItemClick(event, index)}
                >
                  {option}
                </MenuItem>
              ))}
            </Menu>
          </div>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <FaBars className="" />
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="justify-content-end align-items-end w-100">
              <Nav.Link className={classes.navItem} onClick={handlePricingInfo}>
                {t('pricingPopup.nav')}
              </Nav.Link>
              <a target="_blank" className={classes.navItem} href='https://quickey-docs.netlify.app'>
                {t('nav.docs')}
              </a>
              <a target="_blank" className={classes.navItem} href={CONTACT_US_URL}>
                {t('nav.contactUs')}
              </a>
              {/* <Nav.Link className={classes.navItem} onClick={gotoLoginPage}>
              {t('nav.login')}
              </Nav.Link> */}
              <Nav.Link className="font-size-14 btn-white reguler" style={{padding:"3px 15px"}} onClick={gotoSignUpPage}>
              {t('nav.login')}
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </Grid>
    </Grid>
  );
}

export default withTranslation()(NavbarHomepage);